import React from 'react';

const ActionButtons = ({ onBack, onReset, onSave, isSaving, t }) => {

  return (
    <div className="d-flex gap-3 pt-3">
      <button
        type="button"
        className="btn btn-outline-secondary"
        onClick={onBack}
        data-testid="back-button"
      >
        <i className="bi bi-arrow-left me-2"></i>
        {t('backToDashboard')}
      </button>
      <button
        type="button"
        className="btn btn-outline-secondary"
        onClick={onReset}
        data-testid="reset-button"
      >
        {t('resetToDefault')}
      </button>
      <button
        type="button"
        className="btn btn-success ms-auto"
        style={{ minWidth: '200px' }}
        onClick={onSave}
        disabled={isSaving}
        data-testid="save-button"
      >
        {isSaving ? t('saving') : t('saveTargetSettings')}
      </button>
    </div>
  );
};

export default ActionButtons;
